import * as React from "react";
const Compass = ({ title, titleId, desc, descId }) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 96 96", "aria-labelledby": titleId, "aria-describedby": descId },
    desc ? React.createElement("desc", { id: descId }, desc) : null,
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("mask", { id: "prefix__a", width: 94, height: 94, x: 1, y: 1, maskUnits: "userSpaceOnUse", style: {
            maskType: "luminance",
        } },
        React.createElement("path", { fill: "#fff", d: "M94.5 1.5h-93v93h93z" })),
    React.createElement("g", { mask: "url(#prefix__a)" },
        React.createElement("mask", { id: "prefix__b", width: 94, height: 94, x: 1, y: 1, maskUnits: "userSpaceOnUse", style: {
                maskType: "luminance",
            } },
            React.createElement("path", { fill: "#fff", d: "M94.5 1.5h-93v93h93z" })),
        React.createElement("g", { mask: "url(#prefix__b)" },
            React.createElement("path", { fill: "#ED0000", d: "M59.8 59.7 36.3 36.3l33.8-10.5z" }),
            React.createElement("path", { fill: "#3F3F3F", d: "m36.3 36.3 23.5 23.4-33.9 10.5z" }),
            React.createElement("path", { fill: "#CFCFCF", d: "M47.9 94.6c-25.6 0-46.5-20.9-46.5-46.5S22.3 1.6 47.9 1.6s46.5 20.9 46.5 46.5-20.8 46.5-46.5 46.5m0-81.5c-19.3 0-35 15.7-35 35s15.7 35 35 35 35-15.7 35-35-15.7-35-35-35" })))));
export default Compass;
//# sourceMappingURL=Compass.js.map